import React from 'react';
import PropTypes from 'prop-types';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ErrorPrompt from '../ErrorPrompt/ErrorPrompt';

const renderChildren = (children) => (typeof children === 'function' ? children() : children);

const Loading = ({ children, displayLoader, errorMessage, hasError, isLoading, loader, onReload }) => {
  return (
    <ErrorPrompt customErrorMessage={errorMessage} displayError={hasError} onReload={onReload}>
      {isLoading || hasError ? displayLoader && loader : renderChildren(children)}
    </ErrorPrompt>
  );
};

Loading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.func, PropTypes.string, PropTypes.bool]),
  displayLoader: PropTypes.bool,
  errorMessage: PropTypes.string,
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool,
  loader: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.func, PropTypes.string]),
  onReload: PropTypes.func,
};

Loading.defaultProps = {
  children: null,
  displayLoader: true, // <-- "set to true to make it backwards compatible with components that are already using "Loading" directly"
  errorMessage: 'Unable to load data',
  hasError: false,
  isLoading: false,
  loader: (
    <div className="d-flex justify-content-center p-45">
      <FiberManualRecordIcon className="spinner-grow" fontSize="large" />
      <FiberManualRecordIcon className="spinner-grow" fontSize="large" />
      <FiberManualRecordIcon className="spinner-grow" fontSize="large" />
    </div>
  ),
  onReload: null,
};

export default Loading;
